import * as React from 'react';

import Widget from 'bundles/ai-course-coach/components/ChatWidget';
import type { AnyFunction, HomeView } from 'bundles/ai-course-coach/utils/types';

export type Props = {
  handleNewUserMessage: AnyFunction;
  senderPlaceHolder?: string;
  showFullScreenButton?: boolean;
  autofocus?: boolean;
  profileClientAvatar?: string;
  launcher?: AnyFunction;
  handleTextInputChange?: (text: string) => void;
  chatId?: string;
  handleToggle?: AnyFunction;
  showCloseButton?: boolean;
  handleNewSession?: () => void;
  homeView?: HomeView;
  loading?: boolean;
  courseId?: string;
  handleFullScreenToggle?: AnyFunction;
} & typeof defaultProps;

function ConnectedWidget({
  senderPlaceHolder,
  showFullScreenButton,
  autofocus,
  profileClientAvatar,
  launcher,
  handleNewUserMessage,
  handleTextInputChange,
  chatId,
  handleToggle,
  showCloseButton,
  handleNewSession,
  homeView,
  loading,
  courseId,
  handleFullScreenToggle,
}: Props) {
  return (
    <Widget
      handleNewUserMessage={handleNewUserMessage}
      senderPlaceHolder={senderPlaceHolder}
      profileClientAvatar={profileClientAvatar}
      showCloseButton={showCloseButton}
      showFullScreenButton={showFullScreenButton}
      autofocus={autofocus}
      customLauncher={launcher}
      handleTextInputChange={handleTextInputChange}
      chatId={chatId}
      handleToggle={handleToggle}
      handleNewSession={handleNewSession}
      homeView={homeView}
      loading={loading}
      courseId={courseId}
      handleFullScreenToggle={handleFullScreenToggle}
    />
  );
}

const defaultProps = {
  senderPlaceHolder: 'Type a message...',
  showCloseButton: true,
  showFullScreenButton: true,
  autofocus: true,
  chatId: 'coach-chat-container',
  launcherOpenLabel: 'Open chat',
  launcherCloseLabel: 'Close chat',
  launcherOpenImg: '',
  launcherCloseImg: '',
  zoomStep: 80,
  showBadge: true,
};
ConnectedWidget.defaultProps = defaultProps;

export default ConnectedWidget;
